import { colors } from "../../../ui/colors";
import { EventType } from "../dto";

export const eventsColorsMap = new Map<EventType, { text: string, bg: string, border: string }>([
    [EventType.CALL, { text: colors.brandPrimary[800], bg: colors.brandPrimary[100], border: colors.brandPrimary[300] }],
])